<div class="row-chips"
  [ngClass]="{'show-chips': chipsState | async}">
  <ng-content select="div.row-details"></ng-content>
  @if ((chipsState | async) && (tags !== null && tags !== undefined)) {
    <aa-chips-tags-container [tags]="tags | async"
      (attachTagEvent)="onAttachTagEvent($event)"
      (detachTagEvent)="onDetachTagEvent($event)"
      [isFiltrable]="isFiltrable">
    </aa-chips-tags-container>
  }
</div>
